export default "__VITE_ASSET__BHzsvjP9__"